<script setup>
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'
import Jumbo from '@/components/Docs/Jumbo.vue'
  
</script>

<template>
  <div class="row">
    <doc-section title="Access">
      <template v-slot:left>
Endpoints represent specific resources or functionalities exposed by the API. Each endpoint corresponds to a unique URL that you can send HTTP requests to in order to perform actions or retrieve data. Familiarize yourself with the available endpoints and the data they provide, by exploring the sidebar to the right.
<br><br>
All endpoints use the same base url: https://api.webscout.io. For brevity and clarity, this part will be omitted for urls referenced throughout the documentation.
      </template>

      <template v-slot:right>
        <code-block title="Base url" text>
          https://api.webscout.io
        </code-block>

        <code-block title="/hello" method="GET" text>
          https://api.webscout.io/hello
        </code-block>
      
      </template>
    </doc-section>

  </div>
</template>


<style scoped>
</style>
